import React from 'react';
import { Text } from "../..";
export var DashBetweenInputs = function () { return (React.createElement(Text, { lss: {
        display: 'none',
        mx: 'md',
        tablet: { display: 'inline', mb: 'sm' }
    } }, "-")); };
//# sourceMappingURL=DashBetweenInputs.js.map